/**
 * Priviax logo assets.
 * - full: PNG con escudo + wordmark (recibido del usuario)
 * - mark: SVG del escudo solo, para favicon y espacios reducidos.
 */

export function LogoFull({ className = '', height = 32 }) {
  return (
    <img
      src="/priviax-logo.png"
      alt="Priviax"
      style={{ height, width: 'auto' }}
      className={className}
      data-testid="priviax-logo-full"
    />
  );
}

export function LogoMark({ size = 28, dark = false }) {
  const stroke = dark ? '#FFFFFF' : '#143A34';
  const check = '#2A9B68';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="priviax-logo-mark"
    >
      <path
        d="M24 4 L42 10 V22 C42 32 34 40 24 44 C14 40 6 32 6 22 V10 Z"
        stroke={stroke}
        strokeWidth="3"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17 15 H25 A5 5 0 0 1 25 25 H17 M17 15 V33"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M20 30 L24 34 L32 25"
        stroke={check}
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default LogoFull;
